module.exports = __webpack_public_path__ + "static/media/32.fd6310bc.ogg";